export default __webpack_public_path__ + "static/media/Banner-Vista-Bosque.d66b0ad1.png";